import React from "react";

export default function ProgressDashes({ current, total }) {
  return (
    <div className="survey-progress">
      {Array.from({ length: total }, (_, index) => (
        <span
          className={`survey-dash${index < current ? " active" : ""}`}
          key={index}
        />
      ))}
    </div>
  );
}
